// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"79ed9b1e","719":"137152e2"}[chunkId] + ".chunk.js";
};